import React from 'react';
import Button from '@amzn/meridian/button';
import { FormattedMessage } from 'react-intl';
import Auth from '../../../Auth';

interface DismissButtonProps {
  externalId: string;
  dismissable: boolean;
  handleDismiss(id: string): void;
  notificationMetadata: {
    notificationCategory?: string;
    notificationType?: string;
  };
}

export const DismissButton: React.FC<DismissButtonProps> = ({
  externalId,
  dismissable,
  handleDismiss,
  notificationMetadata,
}: DismissButtonProps): React.ReactElement => {
  return (
    <>
      {dismissable && (
        <>
          <Button
            onClick={() => handleDismiss(externalId)}
            type='secondary'
            size='medium'
            disabled={Auth.isImpersonating()}
            data-csa-c-type='button'
            data-csa-c-slot-id='click-on-Dismiss-button-slot'
            data-csa-c-content-id='click-on-Dismiss-button'
            data-csa-c-description='Click on Notification Dismiss button'
            data-csa-c-tag1='Notifications'
            data-csa-c-notification-category={
              notificationMetadata &&
              `${notificationMetadata.notificationCategory}`
            }
            data-csa-c-notification-type={
              notificationMetadata && `${notificationMetadata.notificationType}`
            }
            data-csa-c-notification-id={`${externalId}`}
          >
            <FormattedMessage
              id='cs_perfportal_notifications_dismiss_button'
              defaultMessage='Dismiss'
              description='Notification Dismiss button'
            />
          </Button>

          <span style={{ paddingLeft: '10px' }}></span>
        </>
      )}
    </>
  );
};
